// import {
//   ArrowMoveRight,
//   Check,
//   ClockPause,
//   PlaneArrival,
//   PlaneDeparture,
//   PlaneInflight,
//   PlaneOff,
//   AlertTriangle,
//   Clock,
// } from "tabler-icons-react";
// import {
//   Card,
//   Button,
//   Modal,
//   Title,
//   Anchor,
//   Badge,
//   Paper,
//   Text,
//   Group,
//   Select,
//   Divider,
//   Accordion,
//   Stack,
//   Box,
// } from "@mantine/core";
// import { useEffect, useState } from "react";
// import { useDisclosure } from "@mantine/hooks";
// import { DateInput } from "@mantine/dates";
// import { getUserCredits, getFlightTrack } from "../misc/api";
// import {
//   formatHumanFriendlyDate,
//   getGrinTime,
//   getTimeDifference,
//   addTimes,
// } from "../misc/time";
// import { getGroup } from "../misc/tokens";
// import { IconInfoCircle } from "@tabler/icons-react";

// const getFlightStatus = (flight, currentTime) => {
//   const currentDOF = new Date().toISOString().slice(2, 10).replace(/-/g, "");
//   const isToday = flight.dof === currentDOF;
//   const isPastDate = flight.dof < currentDOF;

//   if (flight.cnc_msg || flight.cancelled === "1") {
//     return {
//       status: "CANCELLED",
//       color: "#540101cc",
//       icon: <PlaneOff strokeWidth={1} size="35" color="white" />,
//       badge: null,
//     };
//   }

//   if (flight.act_arr && flight.arr_msg) {
//     const scheduledArrival = addTimes(flight.original_dep_time, flight.original_arr_time);
//     const isLate = flight.act_arr > scheduledArrival;
//     return {
//       status: "LANDED",
//       color: "#3e8f00",
//       icon: <Check strokeWidth={1} size="35" color="white" />,
//       badge: isLate ? (
//         <Badge color="orange" size="xs" leftSection={<Clock size={12} />}>
//           Late Arrival
//         </Badge>
//       ) : null,
//       actualArrival: flight.act_arr,
//     };
//   }

//   if (flight.act_dep && flight.dep_msg && !flight.arr_msg) {
//     const expectedArrival = addTimes(flight.act_dep, flight.arrival_time);
//     const minutesUntilExpectedArrival = getTimeDifference(currentTime, expectedArrival);
//     const isOverdue = minutesUntilExpectedArrival < -30;
//     return {
//       status: "IN FLIGHT",
//       color: "#1e40af",
//       icon: <PlaneInflight size="35" color="white" />,
//       badge: isOverdue ? (
//         <Badge color="red" size="xs" leftSection={<AlertTriangle size={12} />}>
//           Overdue - No ARR
//         </Badge>
//       ) : null,
//       actualDeparture: flight.act_dep,
//     };
//   }

//   if (isToday) {
//     const minutesPastDeparture = getTimeDifference(flight.departure_time, currentTime);

//     if (minutesPastDeparture > 15 && !flight.dep_msg) {
//       return {
//         status: "OVERDUE DEP",
//         color: "#a68800",
//         icon: <AlertTriangle size="35" color="white" />,
//         badge: (
//           <Badge color="orange" size="xs" leftSection={<Clock size={12} />}>
//             No DEP Message
//           </Badge>
//         ),
//       };
//     }

//     if (minutesPastDeparture >= -15 && minutesPastDeparture <= 15) {
//       return {
//         status: "DEPARTING SOON",
//         color: "#4338ca",
//         icon: <PlaneDeparture size="35" color="white" />,
//         badge: null,
//       };
//     }
//   }

//   if (flight.dly_msg || flight.delayed === "1") {
//     return {
//       status: "DELAYED",
//       color: "#a68800",
//       icon: <ClockPause size="35" color="white" />,
//       badge: (
//         <Badge color="yellow" size="xs" leftSection={<Clock size={12} />}>
//           Delayed
//         </Badge>
//       ),
//     };
//   }

//   if (isPastDate && !flight.arr_msg) {
//     return {
//       status: "PRESUMED LANDED",
//       color: "#3e8f00",
//       icon: <Check strokeWidth={1} size="35" color="white" />,
//       badge: (
//         <Badge color="gray" size="xs">
//           No ARR Received
//         </Badge>
//       ),
//     };
//   }

//   return {
//     status: "PLANNED",
//     color: "#282c34",
//     icon: <ClockPause size="35" color="white" />,
//     badge: null,
//   };
// };

// // ==================== LATVIAN LEGEND COMPONENT ====================

// const FlightLegend = ({ hasElevatedAccess }) => {
//   return (
//     <Paper style={{marginTop: -60}} p="xs" mb="xs" withBorder>
//       <Group position="apart" mb="xs">
//         <Group>
//           <IconInfoCircle size={24} />
//           <Text weight={700} size="lg">
//             Apzīmējumu skaidrojums
//           </Text>
//         </Group>
//       </Group>

//       <Accordion>
//         <Accordion.Item value="statuses">
//           <Accordion.Control>
//             <Text weight={600}>Lidojuma statusi un krāsas</Text>
//           </Accordion.Control>
//           <Accordion.Panel>
//             <Stack spacing="xs">
//               <Group>
//                 <Box
//                   style={{
//                     width: 20,
//                     height: 20,
//                     backgroundColor: "#3e8f00",
//                     borderRadius: 4,
//                   }}
//                 />
//                 <Text size="sm">
//                   <strong>Zaļš</strong> - Lidmašīna ir nolaikusies (LANDED vai PRESUMED
//                   LANDED)
//                 </Text>
//               </Group>
//               <Group>
//                 <Box
//                   style={{
//                     width: 20,
//                     height: 20,
//                     backgroundColor: "#1e40af",
//                     borderRadius: 4,
//                   }}
//                 />
//                 <Text size="sm">
//                   <strong>Zils</strong> - Lidmašīna ir gaisā (IN FLIGHT)
//                 </Text>
//               </Group>
//               <Group>
//                 <Box
//                   style={{
//                     width: 20,
//                     height: 20,
//                     backgroundColor: "#4338ca",
//                     borderRadius: 4,
//                   }}
//                 />
//                 <Text size="sm">
//                   <strong>Violets</strong> - Drīzumā izlidos (DEPARTING SOON, ±15 min)
//                 </Text>
//               </Group>
//               <Group>
//                 <Box
//                   style={{
//                     width: 20,
//                     height: 20,
//                     backgroundColor: "#282c34",
//                     borderRadius: 4,
//                   }}
//                 />
//                 <Text size="sm">
//                   <strong>Tumši pelēks</strong> - Plānots lidojums (PLANNED)
//                 </Text>
//               </Group>
//               <Group>
//                 <Box
//                   style={{
//                     width: 20,
//                     height: 20,
//                     backgroundColor: "#a68800",
//                     borderRadius: 4,
//                   }}
//                 />
//                 <Text size="sm">
//                   <strong>Dzeltenzaļš</strong> - Aizkavēts vai nokavēts (DELAYED,
//                   OVERDUE DEP)
//                 </Text>
//               </Group>
//               <Group>
//                 <Box
//                   style={{
//                     width: 20,
//                     height: 20,
//                     backgroundColor: "#540101cc",
//                     borderRadius: 4,
//                   }}
//                 />
//                 <Text size="sm">
//                   <strong>Tumši sarkans</strong> - Atcelts lidojums (CANCELLED)
//                 </Text>
//               </Group>
//             </Stack>
//           </Accordion.Panel>
//         </Accordion.Item>

//         <Accordion.Item value="times">
//           <Accordion.Control>
//             <Text weight={600}>Laiku apzīmējumi</Text>
//           </Accordion.Control>
//           <Accordion.Panel>
//             <Stack spacing="xs">
//               <Group>
//                 <Text size="sm" style={{ color: "#ffffff" }}>
//                   <strong style={{ color: "#ffffff", backgroundColor: 'black' }}>Balts</strong>
//                 </Text>
//                 <Text size="sm">- Plānotais laiks (STD/STA - Scheduled Time)</Text>
//               </Group>
//               <Group>
//                 <Text size="sm" style={{ color: "#ffa500" }}>
//                   <strong style={{ color: "#ffa500" }}>Oranžs</strong>
//                 </Text>
//                 <Text size="sm">- Mainītais laiks (ETD/ETA - Estimated Time)</Text>
//               </Group>
//               <Group>
//                 <Text size="sm" style={{ color: "#00ff00" }}>
//                   <strong style={{ color: "#00ff00" }}>Zaļš</strong>
//                 </Text>
//                 <Text size="sm">- Faktiskais laiks (ATD/ATA - Actual Time)</Text>
//               </Group>
//               <Divider my="xs" />
//               <Text size="sm">
//                 <strong>STD</strong> - Scheduled Time of Departure (Plānotais izlidošanas laiks)
//               </Text>
//               <Text size="sm">
//                 <strong>ETD</strong> - Estimated Time of Departure (Paredzamais izlidošanas laiks)
//               </Text>
//               <Text size="sm">
//                 <strong>ATD</strong> - Actual Time of Departure (Faktiskais izlidošanas laiks)
//               </Text>
//               <Text size="sm">
//                 <strong>STA</strong> - Scheduled Time of Arrival (Plānotais ielidošanas laiks)
//               </Text>
//               <Text size="sm">
//                 <strong>ETA</strong> - Estimated Time of Arrival (Paredzamais ielidošanas laiks)
//               </Text>
//               <Text size="sm">
//                 <strong>ATA</strong> - Actual Time of Arrival (Faktiskais ielidošanas laiks)
//               </Text>
//             </Stack>
//           </Accordion.Panel>
//         </Accordion.Item>

//         {hasElevatedAccess && (
//           <Accordion.Item value="ppr">
//             <Accordion.Control>
//               <Text weight={600}>PPR apzīmējumi (tikai hasElevatedAccessistrācijai)</Text>
//             </Accordion.Control>
//             <Accordion.Panel>
//               <Stack spacing="xs">
//                 <Group>
//                   <div
//                     style={{
//                       width: 10,
//                       height: 20,
//                       backgroundColor: "#00ff00",
//                       borderRadius: 2,
//                     }}
//                   />
//                   <Text size="sm">
//                     <strong>Zaļa kreisā mala</strong> - PPR ir reģistrēts sistēmā
//                   </Text>
//                 </Group>
//                 <Group>
//                   <div
//                     style={{
//                       width: 10,
//                       height: 20,
//                       backgroundColor: "#ffaa00",
//                       borderRadius: 2,
//                     }}
//                   />
//                   <Text size="sm">
//                     <strong>Oranža kreisā mala</strong> - PPR nav reģistrēts sistēmā
//                   </Text>
//                 </Group>
//                 <Group>
//                   <Badge color="green" size="lg">
//                     PPR ✓
//                   </Badge>
//                   <Text size="sm">- PPR ir reģistrēts un apstiprināts</Text>
//                 </Group>
//               </Stack>
//             </Accordion.Panel>
//           </Accordion.Item>
//         )}

//         {hasElevatedAccess && (
//           <Accordion.Item value="messages">
//             <Accordion.Control>
//               <Text weight={600}>AFTN ziņojumu apzīmējumi (tikai hasElevatedAccessistrācijai)</Text>
//             </Accordion.Control>
//             <Accordion.Panel>
//               <Stack spacing="xs">
//                 <Group>
//                   <Badge color="blue" size="sm">
//                     FPL
//                   </Badge>
//                   <Text size="sm">Flight Plan - Lidojuma plāns iesniegts</Text>
//                 </Group>
//                 <Group>
//                   <Badge color="orange" size="sm">
//                     CHG
//                   </Badge>
//                   <Text size="sm">Change - Lidojuma plāns mainīts</Text>
//                 </Group>
//                 <Group>
//                   <Badge color="green" size="sm">
//                     DEP
//                   </Badge>
//                   <Text size="sm">Departure - Izlidošanas ziņojums</Text>
//                 </Group>
//                 <Group>
//                   <Badge color="green" size="sm">
//                     ARR
//                   </Badge>
//                   <Text size="sm">Arrival - Ielidošanas ziņojums</Text>
//                 </Group>
//                 <Group>
//                   <Badge color="yellow" size="sm">
//                     DLY
//                   </Badge>
//                   <Text size="sm">Delay - Kavēšanās ziņojums</Text>
//                 </Group>
//                 <Group>
//                   <Badge color="red" size="sm">
//                     CNL
//                   </Badge>
//                   <Text size="sm">Cancel - Atcelšanas ziņojums</Text>
//                 </Group>
//               </Stack>
//             </Accordion.Panel>
//           </Accordion.Item>
//         )}

//         <Accordion.Item value="badges">
//           <Accordion.Control>
//             <Text weight={600}>Statusa marķieri</Text>
//           </Accordion.Control>
//           <Accordion.Panel>
//             <Stack spacing="xs">
//               <Group>
//                 <Badge color="orange" size="xs" leftSection={<Clock size={12} />}>
//                   Late Arrival
//                 </Badge>
//                 <Text size="sm">- Lidmašīna nokavēja plānoto ielidošanas laiku</Text>
//               </Group>
//               <Group>
//                 <Badge color="red" size="xs" leftSection={<AlertTriangle size={12} />}>
//                   Overdue - No ARR
//                 </Badge>
//                 <Text size="sm">- Nav saņemts ielidošanas ziņojums, lidmašīna ir pārāk ilgi gaisā</Text>
//               </Group>
//               <Group>
//                 <Badge color="orange" size="xs" leftSection={<Clock size={12} />}>
//                   No DEP Message
//                 </Badge>
//                 <Text size="sm">- Nav saņemts izlidošanas ziņojums 15 min pēc plānotā laika</Text>
//               </Group>
//               <Group>
//                 <Badge color="yellow" size="xs" leftSection={<Clock size={12} />}>
//                   Delayed
//                 </Badge>
//                 <Text size="sm">- Lidojums ir aizkavēts</Text>
//               </Group>
//               <Group>
//                 <Badge color="gray" size="xs">
//                   No ARR Received
//                 </Badge>
//                 <Text size="sm">- Lidojums ir pagājušā datumā, bet nav saņemts ARR ziņojums</Text>
//               </Group>
//             </Stack>
//           </Accordion.Panel>
//         </Accordion.Item>
//       </Accordion>
//     </Paper>
//   );
// };

// // ==================== TIME DISPLAY COMPONENT ====================

// const TimeDisplay = ({ label, time, isActual, isChanged }) => {
//   const getColor = () => {
//     if (isActual) return "#00ff00";
//     if (isChanged) return "#ffa500";
//     return "#ffffff";
//   };

//   if (!time) return null;

//   return (
//     <div style={{ padding: 5 }}>
//       <div style={{ fontSize: 10, opacity: 0.8 }}>{label}</div>
//       <div style={{ color: getColor(), fontWeight: isActual ? "bold" : "normal" }}>
//         {time.slice(0, -3)}
//       </div>
//     </div>
//   );
// };

// // ==================== MESSAGE INDICATORS ====================

// const MessageIndicators = ({ flight, hasElevatedAccess }) => {
//   const messages = [];

//   if (flight.original_msg) {
//     messages.push({ type: "FPL", color: "blue", tooltip: "Flight Plan Filed" });
//   }
//   if (flight.chg_msg) {
//     messages.push({ type: "CHG", color: "orange", tooltip: "Flight Changed" });
//   }
//   if (flight.dep_msg) {
//     messages.push({ type: "DEP", color: "green", tooltip: "Departure Message" });
//   }
//   if (flight.arr_msg) {
//     messages.push({ type: "ARR", color: "green", tooltip: "Arrival Message" });
//   }
//   if (flight.dly_msg) {
//     messages.push({ type: "DLY", color: "yellow", tooltip: "Delay Message" });
//   }
//   if (flight.cnc_msg) {
//     messages.push({ type: "CNL", color: "red", tooltip: "Cancellation" });
//   }

//   if (!hasElevatedAccess || messages.length === 0) return null;

//   return (
//     <div style={{ display: "flex", gap: 3, marginTop: 5 }}>
//       {messages.map((msg, idx) => (
//         <Badge key={idx} size="xs" color={msg.color} title={msg.tooltip}>
//           {msg.type}
//         </Badge>
//       ))}
//     </div>
//   );
// };

// // ==================== MODAL ELEMENT ====================

// const ModalElement = ({ msg }) => {
//   return (
//     <div
//       style={msg ? { borderTop: "1px solid black", paddingTop: 5, paddingBottom: 5 } : {}}
//     >
//       {msg}
//     </div>
//   );
// };

// // ==================== MAIN FLIGHT SCREEN COMPONENT ====================

// function FlightScreen() {
//   const [flights, setFlights] = useState([]);
//   const [grin, setGrin] = useState(getGrinTime());
//   const [modal, setModal] = useState();
//   const [opened, { open, close }] = useDisclosure(false);
//   const [credits, setCredits] = useState(null);

//   // Date sorting/filtering states
//   const [sortBy, setSortBy] = useState("date_desc"); // date_desc, date_asc, departure, arrival
//   const [dateFilter, setDateFilter] = useState(null);
//   const [groupByDate, setGroupByDate] = useState(true);

//   const hasElevatedAccess = getGroup() == 0;

//   useEffect(() => {
//     if (hasElevatedAccess) {
//       setCredits(true);
//       return;
//     }

//     getUserCredits().then((x) => {
//       if (x[0]?.product == "tms") return setCredits(true);
//       if (x[0]?.product == "sms") return setCredits(true);
//       if (x[0]?.product == "ys") return setCredits(true);
//       return setCredits(false);
//     });
//   }, []);

//   const modalCall = (data) => {
//     setModal(data);
//     open();
//   };

//   useEffect(() => {
//     const getFlightsData = async () => {
//       try {
//         const response = await getFlightTrack();
//         const flightData = response.data || [];

//         // Apply date filter
//         let filteredFlights = flightData;
//         if (dateFilter) {
//           const filterDate = dateFilter.toISOString().slice(2, 10).replace(/-/g, "");
//           filteredFlights = flightData.filter((flight) => flight.dof === filterDate);
//         }

//         // Sort flights
//         const sortedFlights = [...filteredFlights].sort((a, b) => {
//           switch (sortBy) {
//             case "date_asc":
//               return a.dof.localeCompare(b.dof) || a.departure_time.localeCompare(b.departure_time);
//             case "date_desc":
//               return b.dof.localeCompare(a.dof) || a.departure_time.localeCompare(b.departure_time);
//             case "departure":
//               return a.departure_time.localeCompare(b.departure_time);
//             case "arrival":
//               const arrA = addTimes(a.departure_time, a.arrival_time);
//               const arrB = addTimes(b.departure_time, b.arrival_time);
//               return arrA.localeCompare(arrB);
//             default:
//               return 0;
//           }
//         });

//         setFlights(sortedFlights);
//       } catch (error) {
//         console.error("Error fetching flights:", error);
//       }
//     };

//     const updateGrinTime = () => {
//       setGrin(getGrinTime());
//     };

//     if (credits) {
//       getFlightsData();
//     }

//     const flightsIntervalId = setInterval(getFlightsData, 30000);
//     const grinIntervalId = setInterval(updateGrinTime, 30000);

//     return () => {
//       clearInterval(flightsIntervalId);
//       clearInterval(grinIntervalId);
//     };
//   }, [credits, sortBy, dateFilter]);

//   // Group flights by date
//   const groupFlightsByDate = (flights) => {
//     if (!groupByDate) return { all: flights };

//     const grouped = {};
//     flights.forEach((flight) => {
//       if (!grouped[flight.dof]) {
//         grouped[flight.dof] = [];
//       }
//       grouped[flight.dof].push(flight);
//     });
//     return grouped;
//   };

//   const groupedFlights = groupFlightsByDate(flights);

//   const renderFlightCard = (flight) => {
//     const flightStatus = getFlightStatus(flight, grin);
//     const times = {
//       scheduledDeparture: flight.original_dep_time,
//       estimatedDeparture: flight.departure_time,
//       actualDeparture: flight.act_dep,
//       departureChanged: flight.original_dep_time !== flight.departure_time,
//       scheduledArrival: addTimes(flight.original_dep_time, flight.original_arr_time),
//       estimatedArrival: addTimes(flight.departure_time, flight.arrival_time),
//       actualArrival: flight.act_arr,
//       arrivalChanged: flight.original_arr_time !== flight.arrival_time,
//       plannedDuration: flight.original_arr_time,
//       currentDuration: flight.arrival_time,
//     };

//     return (
//       <a key={flight.fid} onClick={() => modalCall(flight)}>
//         <Card
//           withBorder
//           style={{
//             backgroundColor: flightStatus.color,
//             borderLeft: hasElevatedAccess
//               ? flight.has_ppr_in_system
//                 ? "10px solid #00ff00"
//                 : flight.ppr
//                 ? "10px solid #ffaa00"
//                 : "10px solid transparent"
//               : "none",
//             marginBottom: 10,
//             cursor: "pointer",
//             position: "relative",
//           }}
//           shadow="sm"
//         >
//           {hasElevatedAccess && flight.has_ppr_in_system && (
//             <Badge
//               color="green"
//               variant="filled"
//               size="xl"
//               style={{
//                 position: "absolute",
//                 top: 8,
//                 right: 8,
//                 zIndex: 1,
//               }}
//             >
//               PPR ✓
//             </Badge>
//           )}

//           <div
//             style={{
//               display: "flex",
//               flexDirection: "row",
//               color: "white",
//               justifyContent: "space-between",
//               alignItems: "center",
//             }}
//           >
//             <div>
//               {flightStatus.icon}

//               <div>
//                 {flight.plane_nr}
//                 <span style={{ fontSize: 12 }}> ({flight.plane_type})</span>
//               </div>

//               <div style={{ fontSize: 10 }}>PPR: {flight.ppr || "N/A"}</div>

//               {hasElevatedAccess && flight.has_ppr_in_system && (
//                 <div style={{ fontSize: 10, marginTop: 2, color: "#aaa" }}>
//                   User: {flight.user_name} {flight.user_surname}
//                   {flight.has_flight_request && <span> • Req #{flight.request_id}</span>}
//                 </div>
//               )}

//               <div style={{ marginTop: 5 }}>
//                 <strong>{flightStatus.status}</strong>
//                 {flightStatus.badge && <div style={{ marginTop: 3 }}>{flightStatus.badge}</div>}
//               </div>

//               <MessageIndicators flight={flight} hasElevatedAccess={hasElevatedAccess} />
//             </div>

//             <div
//               style={{
//                 display: "flex",
//                 flexDirection: "row",
//                 justifyContent: "space-between",
//                 width: 450,
//                 alignItems: "center",
//               }}
//             >
//               <div>
//                 <span style={flight.departure_place === "EVRS" ? { fontWeight: 800 } : {}}>
//                   {flight.departure_place}
//                 </span>
//                 <div style={{ fontSize: 12, display: "flex", flexDirection: "row" }}>
//                   <TimeDisplay
//                     label="STD"
//                     time={times.scheduledDeparture}
//                     isActual={false}
//                     isChanged={false}
//                   />
//                   <TimeDisplay
//                     label="ETD"
//                     time={times.estimatedDeparture}
//                     isActual={false}
//                     isChanged={times.departureChanged}
//                   />
//                   <TimeDisplay
//                     label="ATD"
//                     time={times.actualDeparture}
//                     isActual={true}
//                     isChanged={false}
//                   />
//                 </div>
//               </div>

//               <div>
//                 <div style={{ fontSize: 11, marginTop: 15 }}>
//                   <div style={{ marginBottom: -20 }}>
//                     {formatHumanFriendlyDate(flight.dof)}
//                   </div>
//                   <ArrowMoveRight size="60" strokeWidth={0.5} style={{ marginBottom: -20 }} />
//                   <div style={{ marginBottom: 20 }}>
//                     Duration: {times.currentDuration?.slice(0, -3)}
//                   </div>
//                 </div>
//               </div>

//               <div>
//                 <span style={flight.arrival_place === "EVRS" ? { fontWeight: 800 } : {}}>
//                   {flight.arrival_place}
//                 </span>
//                 <div style={{ fontSize: 12, display: "flex", flexDirection: "row" }}>
//                   <TimeDisplay
//                     label="STA"
//                     time={times.scheduledArrival}
//                     isActual={false}
//                     isChanged={false}
//                   />
//                   <TimeDisplay
//                     label="ETA"
//                     time={times.estimatedArrival}
//                     isActual={false}
//                     isChanged={times.arrivalChanged}
//                   />
//                   <TimeDisplay
//                     label="ATA"
//                     time={times.actualArrival}
//                     isActual={true}
//                     isChanged={false}
//                   />
//                 </div>
//               </div>
//             </div>

//             <div style={{ width: 100 }}></div>
//           </div>

//           <div style={{ color: "white", fontSize: 12, marginTop: 10 }}>
//             {JSON.parse(flight.phone || "[]").map((phone, index) => (
//               <span key={index}>{phone}; </span>
//             ))}
//           </div>
//         </Card>
//       </a>
//     );
//   };

//   return (
//     <>
//       {credits ? (
//         <div className="App" style={{ marginLeft: -15, marginRight: -15 }}>
//           <Modal opened={opened} onClose={close} title="AFTN Messages">
//             <ModalElement msg={modal && modal.original_msg} />
//             <ModalElement msg={modal && modal.chg_msg} />
//             <ModalElement msg={modal && modal.dly_msg} />
//             <ModalElement msg={modal && modal.dep_msg} />
//             <ModalElement msg={modal && modal.arr_msg} />
//             <ModalElement msg={modal && modal.cnc_msg} />
//           </Modal>

//           <div style={{ padding: 10, marginBottom: 10 }}>
//             <span style={{ fontSize: 18, fontWeight: "bold", color: "white" }}>
//               GMT: {grin}
//             </span>
//           </div>

//           {/* Legend Component */}
//           <FlightLegend hasElevatedAccess={hasElevatedAccess} />

//           {/* Sorting and Filtering Controls */}
//           <Paper p="xs" mb="xs" withBorder>
//             <Group position="apart" mb="sm">
//               <Text weight={600} size="lg">
//                 Filtrēt un kārtot
//               </Text>
//             </Group>

//             <Group grow>
//               <Select
//                 label="Kārtot pēc"
//                 value={sortBy}
//                 onChange={setSortBy}
//                 data={[
//                   { value: "date_desc", label: "Datums (jaunākie vispirms)" },
//                   { value: "date_asc", label: "Datums (vecākie vispirms)" },
//                   { value: "departure", label: "Izlidošanas laiks" },
//                   { value: "arrival", label: "Ielidošanas laiks" },
//                 ]}
//               />

//               <DateInput
//                 label="Filtrēt pēc datuma"
//                 placeholder="Izvēlēties datumu"
//                 clearable
//                 value={dateFilter}
//                 onChange={setDateFilter}
//               />

//               <Select
//                 label="Grupēt pēc datuma"
//                 value={groupByDate ? "yes" : "no"}
//                 onChange={(value) => setGroupByDate(value === "yes")}
//                 data={[
//                   { value: "yes", label: "Jā" },
//                   { value: "no", label: "Nē" },
//                 ]}
//               />
//             </Group>
//           </Paper>

//           {groupByDate ? (
//             Object.entries(groupedFlights)
//               .sort(([dateA], [dateB]) =>
//                 sortBy === "date_asc" ? dateA.localeCompare(dateB) : dateB.localeCompare(dateA)
//               )
//               .map(([date, dateFlights]) => (
//                 <div key={date} style={{ marginBottom: 20 }}>
//                   <Paper p="sm" mb="sm" withBorder style={{ backgroundColor: "#2d3748" }}>
//                     <Text weight={700} size="lg" color="white">
//                       {formatHumanFriendlyDate(date)} - {dateFlights.length} lidojumi
//                     </Text>
//                   </Paper>
//                   {dateFlights.map(renderFlightCard)}
//                 </div>
//               ))
//           ) : (
//             <div>{flights.map(renderFlightCard)}</div>
//           )}
//         </div>
//       ) : (
//         <div style={{ margin: 10 }}>
//           <div>
//             <Title order={3}>
//               If You had at least 3 month flight subscription active, in this area you would be
//               able to see the active flight plans for today and previous days
//             </Title>
//           </div>
//           <div>
//             <Anchor href="/buy-credits" style={{ marginTop: 20 }}>
//               <Title order={4}>Buy the subscription here</Title>
//             </Anchor>
//           </div>
//         </div>
//       )}
//     </>
//   );
// }

// export default FlightScreen;

import {
  ArrowMoveRight,
  Check,
  ClockPause,
  PlaneArrival,
  PlaneDeparture,
  PlaneInflight,
  PlaneOff,
  AlertTriangle,
  Clock,
} from "tabler-icons-react";
import {
  Card,
  Button,
  Modal,
  Title,
  Anchor,
  Badge,
  Paper,
  Text,
  Group,
  Select,
  Divider,
  Accordion,
  Stack,
  Box,
} from "@mantine/core";
import { useEffect, useState } from "react";
import { useDisclosure } from "@mantine/hooks";
import { DateInput } from "@mantine/dates";
import { getUserCredits, getFlightTrack } from "../misc/api";
import {
  formatHumanFriendlyDate,
  getGrinTime,
  getTimeDifference,
  addTimes,
} from "../misc/time";
import { getGroup } from "../misc/tokens";
import { IconInfoCircle, IconChevronDown, IconChevronUp } from "@tabler/icons-react";

const getFlightStatus = (flight, currentTime) => {
  const currentDOF = new Date().toISOString().slice(2, 10).replace(/-/g, "");
  const isToday = flight.dof === currentDOF;
  const isPastDate = flight.dof < currentDOF;

  if (flight.cnc_msg || flight.cancelled === "1") {
    return {
      status: "CANCELLED",
      color: "#540101cc",
      icon: <PlaneOff strokeWidth={1} size="28" color="white" />,
      badge: null,
    };
  }

  if (flight.act_arr && flight.arr_msg) {
    const scheduledArrival = addTimes(flight.original_dep_time, flight.original_arr_time);
    const isLate = flight.act_arr > scheduledArrival;
    return {
      status: "LANDED",
      color: "#3e8f00",
      icon: <Check strokeWidth={1} size="28" color="white" />,
      badge: isLate ? (
        <Badge color="orange" size="xs" leftSection={<Clock size={10} />}>
          Late
        </Badge>
      ) : null,
      actualArrival: flight.act_arr,
    };
  }

  if (flight.act_dep && flight.dep_msg && !flight.arr_msg) {
    const expectedArrival = addTimes(flight.act_dep, flight.arrival_time);
    const minutesUntilExpectedArrival = getTimeDifference(currentTime, expectedArrival);
    const isOverdue = minutesUntilExpectedArrival < -30;
    return {
      status: "IN FLIGHT",
      color: "#1e40af",
      icon: <PlaneInflight size="28" color="white" />,
      badge: isOverdue ? (
        <Badge color="red" size="xs" leftSection={<AlertTriangle size={10} />}>
          Overdue
        </Badge>
      ) : null,
      actualDeparture: flight.act_dep,
    };
  }

  if (isToday) {
    const minutesPastDeparture = getTimeDifference(flight.departure_time, currentTime);

    if (minutesPastDeparture > 15 && !flight.dep_msg) {
      return {
        status: "OVERDUE DEP",
        color: "#a68800",
        icon: <AlertTriangle size="28" color="white" />,
        badge: (
          <Badge color="orange" size="xs" leftSection={<Clock size={10} />}>
            No DEP
          </Badge>
        ),
      };
    }

    if (minutesPastDeparture >= -15 && minutesPastDeparture <= 15) {
      return {
        status: "DEPARTING SOON",
        color: "#4338ca",
        icon: <PlaneDeparture size="28" color="white" />,
        badge: null,
      };
    }
  }

  if (flight.dly_msg || flight.delayed === "1") {
    return {
      status: "DELAYED",
      color: "#a68800",
      icon: <ClockPause size="28" color="white" />,
      badge: (
        <Badge color="yellow" size="xs" leftSection={<Clock size={10} />}>
          Delayed
        </Badge>
      ),
    };
  }

  if (isPastDate && !flight.arr_msg) {
    return {
      status: "PRESUMED LANDED",
      color: "#3e8f00",
      icon: <Check strokeWidth={1} size="28" color="white" />,
      badge: (
        <Badge color="gray" size="xs">
          No ARR
        </Badge>
      ),
    };
  }

  return {
    status: "PLANNED",
    color: "#282c34",
    icon: <ClockPause size="28" color="white" />,
    badge: null,
  };
};

// ==================== LATVIAN LEGEND COMPONENT ====================

const FlightLegend = ({ hasElevatedAccess }) => {
  const [isVisible, setIsVisible] = useState(() => {
    const saved = localStorage.getItem('flightLegendVisible');
    return saved !== null ? saved === 'true' : false;
  });

  const toggleVisibility = () => {
    const newValue = !isVisible;
    setIsVisible(newValue);
    localStorage.setItem('flightLegendVisible', String(newValue));
  };

  return (
    <Paper style={{ marginTop: -60 }} p="xs" mb="xs" withBorder>
      <Group position="apart">
        <Group spacing="xs">
          <IconInfoCircle size={18} />
          <Text weight={600} size="sm">
            Apzīmējumu skaidrojums
          </Text>
        </Group>
        <Button
          size="xs"
          variant="subtle"
          compact
          onClick={toggleVisibility}
          rightIcon={isVisible ? <IconChevronUp size={14} /> : <IconChevronDown size={14} />}
        >
          {isVisible ? 'Paslēpt' : 'Rādīt'}
        </Button>
      </Group>

      {isVisible && (
        <Accordion mt="xs">
          <Accordion.Item value="statuses">
            <Accordion.Control>
              <Text weight={600} size="sm">Lidojuma statusi un krāsas</Text>
            </Accordion.Control>
            <Accordion.Panel>
              <Stack spacing="xs">
                <Group spacing="xs">
                  <Box style={{ width: 16, height: 16, backgroundColor: "#3e8f00", borderRadius: 3 }} />
                  <Text size="xs"><strong>Zaļš</strong> - Nolaikusies</Text>
                </Group>
                <Group spacing="xs">
                  <Box style={{ width: 16, height: 16, backgroundColor: "#1e40af", borderRadius: 3 }} />
                  <Text size="xs"><strong>Zils</strong> - Gaisā</Text>
                </Group>
                <Group spacing="xs">
                  <Box style={{ width: 16, height: 16, backgroundColor: "#4338ca", borderRadius: 3 }} />
                  <Text size="xs"><strong>Violets</strong> - Izlidos drīzumā</Text>
                </Group>
                <Group spacing="xs">
                  <Box style={{ width: 16, height: 16, backgroundColor: "#282c34", borderRadius: 3 }} />
                  <Text size="xs"><strong>Tumši pelēks</strong> - Plānots</Text>
                </Group>
                <Group spacing="xs">
                  <Box style={{ width: 16, height: 16, backgroundColor: "#a68800", borderRadius: 3 }} />
                  <Text size="xs"><strong>Dzeltenzaļš</strong> - Aizkavēts</Text>
                </Group>
                <Group spacing="xs">
                  <Box style={{ width: 16, height: 16, backgroundColor: "#540101cc", borderRadius: 3 }} />
                  <Text size="xs"><strong>Tumši sarkans</strong> - Atcelts</Text>
                </Group>
              </Stack>
            </Accordion.Panel>
          </Accordion.Item>

          <Accordion.Item value="times">
            <Accordion.Control>
              <Text weight={600} size="sm">Laiku apzīmējumi</Text>
            </Accordion.Control>
            <Accordion.Panel>
              <Stack spacing="xs">
                <Group spacing="xs">
                  <Text size="xs" style={{ color: "#ffffff", backgroundColor: 'black', padding: '2px 4px' }}>
                    <strong>Balts</strong>
                  </Text>
                  <Text size="xs">- Plānotais (STD/STA)</Text>
                </Group>
                <Group spacing="xs">
                  <Text size="xs" style={{ color: "#ffa500" }}>
                    <strong>Oranžs</strong>
                  </Text>
                  <Text size="xs">- Mainītais (ETD/ETA)</Text>
                </Group>
                <Group spacing="xs">
                  <Text size="xs" style={{ color: "#00ff00" }}>
                    <strong>Zaļš</strong>
                  </Text>
                  <Text size="xs">- Faktiskais (ATD/ATA)</Text>
                </Group>
              </Stack>
            </Accordion.Panel>
          </Accordion.Item>

          {hasElevatedAccess && (
            <Accordion.Item value="ppr">
              <Accordion.Control>
                <Text weight={600} size="sm">PPR apzīmējumi</Text>
              </Accordion.Control>
              <Accordion.Panel>
                <Stack spacing="xs">
                  <Group spacing="xs">
                    <div style={{ width: 8, height: 16, backgroundColor: "#00ff00", borderRadius: 2 }} />
                    <Text size="xs"><strong>Zaļa mala</strong> - PPR reģistrēts</Text>
                  </Group>
                  <Group spacing="xs">
                    <div style={{ width: 8, height: 16, backgroundColor: "#ffaa00", borderRadius: 2 }} />
                    <Text size="xs"><strong>Oranža mala</strong> - PPR nav reģistrēts</Text>
                  </Group>
                </Stack>
              </Accordion.Panel>
            </Accordion.Item>
          )}

          {hasElevatedAccess && (
            <Accordion.Item value="messages">
              <Accordion.Control>
                <Text weight={600} size="sm">AFTN ziņojumi</Text>
              </Accordion.Control>
              <Accordion.Panel>
                <Stack spacing="xs">
                  <Group spacing="xs">
                    <Badge color="blue" size="xs">FPL</Badge>
                    <Text size="xs">Plāns iesniegts</Text>
                  </Group>
                  <Group spacing="xs">
                    <Badge color="orange" size="xs">CHG</Badge>
                    <Text size="xs">Mainīts</Text>
                  </Group>
                  <Group spacing="xs">
                    <Badge color="green" size="xs">DEP</Badge>
                    <Text size="xs">Izlidojis</Text>
                  </Group>
                  <Group spacing="xs">
                    <Badge color="green" size="xs">ARR</Badge>
                    <Text size="xs">Ielidojis</Text>
                  </Group>
                  <Group spacing="xs">
                    <Badge color="yellow" size="xs">DLY</Badge>
                    <Text size="xs">Kavējas</Text>
                  </Group>
                  <Group spacing="xs">
                    <Badge color="red" size="xs">CNL</Badge>
                    <Text size="xs">Atcelts</Text>
                  </Group>
                </Stack>
              </Accordion.Panel>
            </Accordion.Item>
          )}
        </Accordion>
      )}
    </Paper>
  );
};

// ==================== TIME DISPLAY COMPONENT ====================

const TimeDisplay = ({ label, time, isActual, isChanged }) => {
  const getColor = () => {
    if (isActual) return "#00ff00";
    if (isChanged) return "#ffa500";
    return "#ffffff";
  };

  if (!time) return null;

  return (
    <div style={{ padding: '2px 3px' }}>
      <div style={{ fontSize: 8, opacity: 0.7 }}>{label}</div>
      <div style={{ color: getColor(), fontWeight: isActual ? "bold" : "normal", fontSize: 11 }}>
        {time.slice(0, -3)}
      </div>
    </div>
  );
};

// ==================== MESSAGE INDICATORS ====================

const MessageIndicators = ({ flight, hasElevatedAccess }) => {
  const messages = [];

  if (flight.original_msg) messages.push({ type: "FPL", color: "blue" });
  if (flight.chg_msg) messages.push({ type: "CHG", color: "orange" });
  if (flight.dep_msg) messages.push({ type: "DEP", color: "green" });
  if (flight.arr_msg) messages.push({ type: "ARR", color: "green" });
  if (flight.dly_msg) messages.push({ type: "DLY", color: "yellow" });
  if (flight.cnc_msg) messages.push({ type: "CNL", color: "red" });

  if (!hasElevatedAccess || messages.length === 0) return null;

  return (
    <div style={{ display: "flex", gap: 2, marginTop: 3 }}>
      {messages.map((msg, idx) => (
        <Badge key={idx} size="xs" color={msg.color}>
          {msg.type}
        </Badge>
      ))}
    </div>
  );
};

// ==================== MODAL ELEMENT ====================

const ModalElement = ({ msg }) => {
  return (
    <div style={msg ? { borderTop: "1px solid black", paddingTop: 5, paddingBottom: 5 } : {}}>
      {msg}
    </div>
  );
};

// ==================== MAIN FLIGHT SCREEN COMPONENT ====================

function FlightScreen() {
  const [flights, setFlights] = useState([]);
  const [grin, setGrin] = useState(getGrinTime());
  const [modal, setModal] = useState();
  const [opened, { open, close }] = useDisclosure(false);
  const [credits, setCredits] = useState(null);

  const [sortBy, setSortBy] = useState("date_desc");
  const [dateFilter, setDateFilter] = useState(null);
  const [groupByDate, setGroupByDate] = useState(true);

  const group = getGroup();

  const hasElevatedAccess = group == 0 || group == 100;

  useEffect(() => {
    if (hasElevatedAccess) {
      setCredits(true);
      return;
    }

    getUserCredits().then((x) => {
      if (x[0]?.product == "tms") return setCredits(true);
      if (x[0]?.product == "sms") return setCredits(true);
      if (x[0]?.product == "ys") return setCredits(true);
      return setCredits(false);
    });
  }, []);

  const modalCall = (data) => {
    setModal(data);
    open();
  };

  useEffect(() => {
    const getFlightsData = async () => {
      try {
        const response = await getFlightTrack();
        const flightData = response.data || [];

        let filteredFlights = flightData;
        if (dateFilter) {
          const filterDate = dateFilter.toISOString().slice(2, 10).replace(/-/g, "");
          filteredFlights = flightData.filter((flight) => flight.dof === filterDate);
        }

        const sortedFlights = [...filteredFlights].sort((a, b) => {
          switch (sortBy) {
            case "date_asc":
              return a.dof.localeCompare(b.dof) || a.departure_time.localeCompare(b.departure_time);
            case "date_desc":
              return b.dof.localeCompare(a.dof) || a.departure_time.localeCompare(b.departure_time);
            case "departure":
              return a.departure_time.localeCompare(b.departure_time);
            case "arrival":
              const arrA = addTimes(a.departure_time, a.arrival_time);
              const arrB = addTimes(b.departure_time, b.arrival_time);
              return arrA.localeCompare(arrB);
            default:
              return 0;
          }
        });

        setFlights(sortedFlights);
      } catch (error) {
        console.error("Error fetching flights:", error);
      }
    };

    const updateGrinTime = () => {
      setGrin(getGrinTime());
    };

    if (credits) {
      getFlightsData();
    }

    const flightsIntervalId = setInterval(getFlightsData, 30000);
    const grinIntervalId = setInterval(updateGrinTime, 30000);

    return () => {
      clearInterval(flightsIntervalId);
      clearInterval(grinIntervalId);
    };
  }, [credits, sortBy, dateFilter]);

  const groupFlightsByDate = (flights) => {
    if (!groupByDate) return { all: flights };

    const grouped = {};
    flights.forEach((flight) => {
      if (!grouped[flight.dof]) {
        grouped[flight.dof] = [];
      }
      grouped[flight.dof].push(flight);
    });
    return grouped;
  };

  const groupedFlights = groupFlightsByDate(flights);

  const renderFlightCard = (flight) => {
    const flightStatus = getFlightStatus(flight, grin);
    const times = {
      scheduledDeparture: flight.original_dep_time,
      estimatedDeparture: flight.departure_time,
      actualDeparture: flight.act_dep,
      departureChanged: flight.original_dep_time !== flight.departure_time,
      scheduledArrival: addTimes(flight.original_dep_time, flight.original_arr_time),
      estimatedArrival: addTimes(flight.departure_time, flight.arrival_time),
      actualArrival: flight.act_arr,
      arrivalChanged: flight.original_arr_time !== flight.arrival_time,
      plannedDuration: flight.original_arr_time,
      currentDuration: flight.arrival_time,
    };

    return (
      <a key={flight.fid} onClick={() => modalCall(flight)}>
        <Card
          withBorder
          p="7"
          style={{
            backgroundColor: flightStatus.color,
            borderLeft: hasElevatedAccess
              ? flight.has_ppr_in_system
                ? "8px solid #00ff00"
                : flight.ppr
                  ? "8px solid #ffaa00"
                  : "8px solid transparent"
              : "none",
            marginBottom: 6,
            cursor: "pointer",
            position: "relative",
          }}
          shadow="sm"
        >
          {hasElevatedAccess && flight.has_ppr_in_system && (
            <Badge
              color="green"
              variant="filled"
              size="md"
              style={{
                position: "absolute",
                top: 4,
                right: 4,
                zIndex: 1,
              }}
            >
              PPR ✓
            </Badge>
          )}

          <div
            style={{
              display: "flex",
              flexDirection: "row",
              color: "white",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            {/* Left Section - Aircraft & Status */}
            <div style={{ minWidth: 110 }}>
              <Group spacing={4} align="center">
                {flightStatus.icon}
                <div>
                  <div style={{ fontSize: 13, fontWeight: 600, display: "flex", gap: 15 }}>
                    {flight.plane_nr} <MessageIndicators flight={flight} hasElevatedAccess={hasElevatedAccess} />
                  </div>
                  <div style={{ fontSize: 9, opacity: 0.8, textAlign: "left", display: "flex", gap: 15 }}>
                    {flight.plane_type} {flightStatus.badge && <div style={{ marginTop: 2 }}>{flightStatus.badge}</div>}
                  </div>
                </div>
              </Group>

              <div style={{ fontSize: 9, marginTop: 2, textAlign: "left" }}>
                PPR: {flight.ppr || "N/A"}
              </div>

              {hasElevatedAccess && flight.has_ppr_in_system && (
                <div style={{ fontSize: 8, marginTop: 2, color: "#aaa" }}>
                  {flight.user_name} {flight.user_surname}
                  {flight.has_flight_request && <span> • #{flight.request_id}</span>}
                </div>
              )}

              <div style={{ marginTop: 3, textAlign: "left" }}>
                <Text size="xs" weight={600}>{flightStatus.status}</Text>
              </div>

              {/* <MessageIndicators flight={flight} hasElevatedAccess={hasElevatedAccess} /> */}
            </div>

            {/* Middle Section - Route & Times - TIGHTER LAYOUT */}
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                alignItems: "center",
                gap: 8,
              }}
            >
              {/* Departure */}
              <div style={{ textAlign: 'center' }}>
                <div style={flight.departure_place === "EVRS" ? { fontWeight: 700, fontSize: 13 } : { fontSize: 13 }}>
                  {flight.departure_place}
                </div>
                <div style={{ display: "flex", flexDirection: "row" }}>
                  <TimeDisplay
                    label="STD"
                    time={times.scheduledDeparture}
                    isActual={false}
                    isChanged={false}
                  />
                  <TimeDisplay
                    label="ETD"
                    time={times.estimatedDeparture}
                    isActual={false}
                    isChanged={times.departureChanged}
                  />
                  <TimeDisplay
                    label="ATD"
                    time={times.actualDeparture}
                    isActual={true}
                    isChanged={false}
                  />
                </div>
              </div>

              {/* Arrow & Date - COMPACT */}
              <div style={{ textAlign: 'center' }}>
                <div style={{ fontSize: 9 }}>
                  {formatHumanFriendlyDate(flight.dof)}
                </div>
                <ArrowMoveRight size="45" strokeWidth={0.5} />
                <div style={{ fontSize: 9 }}>
                  {times.currentDuration?.slice(0, -3)}
                </div>
              </div>

              {/* Arrival */}
              <div style={{ textAlign: 'center' }}>
                <div style={flight.arrival_place === "EVRS" ? { fontWeight: 700, fontSize: 13 } : { fontSize: 13 }}>
                  {flight.arrival_place}
                </div>
                <div style={{ display: "flex", flexDirection: "row" }}>
                  <TimeDisplay
                    label="STA"
                    time={times.scheduledArrival}
                    isActual={false}
                    isChanged={false}
                  />
                  <TimeDisplay
                    label="ETA"
                    time={times.estimatedArrival}
                    isActual={false}
                    isChanged={times.arrivalChanged}
                  />
                  <TimeDisplay
                    label="ATA"
                    time={times.actualArrival}
                    isActual={true}
                    isChanged={false}
                  />
                </div>
              </div>
            </div>

            {/* Contact Info */}
            {JSON.parse(flight.phone || "[]").length > 0 && (
              <div style={{ fontSize: 9, opacity: 0.8, maxWidth: 100, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                {JSON.parse(flight.phone || "[]")[0]}
              </div>
            )}
          </div>
        </Card>
      </a>
    );
  };

  return (
    <>
      {credits ? (
        <div className="App" style={{ marginLeft: -15, marginRight: -15 }}>
          <Modal opened={opened} onClose={close} title="AFTN Messages">
            <ModalElement msg={modal && modal.original_msg} />
            <ModalElement msg={modal && modal.chg_msg} />
            <ModalElement msg={modal && modal.dly_msg} />
            <ModalElement msg={modal && modal.dep_msg} />
            <ModalElement msg={modal && modal.arr_msg} />
            <ModalElement msg={modal && modal.cnc_msg} />
          </Modal>

          <div style={{ padding: 10, marginBottom: 5 }}>
            <span style={{ fontSize: 16, fontWeight: "bold", color: "white" }}>
              GMT: {grin}
            </span>
          </div>

          {/* Legend Component */}
          <FlightLegend hasElevatedAccess={hasElevatedAccess} />

          {/* Compact Filters */}
          <Paper p="xs" mb="xs" withBorder>
            <Group spacing="xs" grow>
              <Select
                size="xs"
                label="Kārtot"
                value={sortBy}
                onChange={setSortBy}
                data={[
                  { value: "date_desc", label: "Jaunākie" },
                  { value: "date_asc", label: "Vecākie" },
                  { value: "departure", label: "Izlidošana" },
                  { value: "arrival", label: "Ielidošana" },
                ]}
              />

              <DateInput
                size="xs"
                label="Datums"
                placeholder="Filtrēt"
                clearable
                value={dateFilter}
                onChange={setDateFilter}
              />

              <Select
                size="xs"
                label="Grupēt"
                value={groupByDate ? "yes" : "no"}
                onChange={(value) => setGroupByDate(value === "yes")}
                data={[
                  { value: "yes", label: "Jā" },
                  { value: "no", label: "Nē" },
                ]}
              />
            </Group>
          </Paper>

          {/* Flight Cards */}
          {groupByDate ? (
            Object.entries(groupedFlights)
              .sort(([dateA], [dateB]) =>
                sortBy === "date_asc" ? dateA.localeCompare(dateB) : dateB.localeCompare(dateA)
              )
              .map(([date, dateFlights]) => (
                <div key={date} style={{ marginBottom: 10 }}>
                  <Paper p="xs" mb="xs" withBorder style={{ backgroundColor: "#2d3748" }}>
                    <Text weight={600} size="sm" color="white">
                      {formatHumanFriendlyDate(date)} ({dateFlights.length})
                    </Text>
                  </Paper>
                  {dateFlights.map(renderFlightCard)}
                </div>
              ))
          ) : (
            <div>{flights.map(renderFlightCard)}</div>
          )}
        </div>
      ) : (
        <div style={{ margin: 10 }}>
          <div>
            <Title order={3}>
              If You had at least 3 month flight subscription active, in this area you would be
              able to see the active flight plans for today and previous days
            </Title>
          </div>
          <div>
            <Anchor href="/buy-credits" style={{ marginTop: 20 }}>
              <Title order={4}>Buy the subscription here</Title>
            </Anchor>
          </div>
        </div>
      )}
    </>
  );
}

export default FlightScreen;